import { useRouter } from 'next/router'
import { useState } from 'react'

import { TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'

import CustomTabList from '../../components/CustomTabList'
import { tabNamesSubmitted } from 'app/KinerjaPage/constants'
import PanelSummary from 'app/KinerjaPage/components/PanelSummary'
import TabHasilKerjaUtama from './TabHasilKerjaUtama'
import TabHasilKerjaTambahan from './TabHasilKerjaTambahan'
import TabPerilakuKerja from './TabPerilakuKerja'
import { translateSKPPeriod } from 'app/KinerjaPage/utils/kinerja'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

import type { Kinerja } from 'types/kinerja'

interface KinerjaPerencanaanWaitingApprovalAppProps {
  skp: Kinerja
  isSKPFetched: boolean
}

enum TabIndex {
  HASIL_KERJA_UTAMA = 0,
  HASIL_KERJA_TAMBAHAN = 1,
  PERILAKU_KERJA = 2,
}

function KinerjaPerencanaanWaitingApprovalApp({
  skp,
  isSKPFetched,
}: KinerjaPerencanaanWaitingApprovalAppProps) {
  const router = useRouter()

  const [activeTabIndex, setActiveTabIndex] = useState(
    TabIndex.HASIL_KERJA_UTAMA
  )

  const backToHomeKinerja = () => {
    router.push(PENGELOLAAN_KINERJA_GURU_PATH)
  }

  return (
    <div className="py-[50px] px-[116px]">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <Icon onClick={backToHomeKinerja} data-testid="icon-back">
            arrow_back
          </Icon>
          <Text variant="display-md">Perencanaan Kinerja</Text>
        </div>

        <PanelSummary
          isLoading={!isSKPFetched}
          items={[
            {
              label: translateSKPPeriod(skp.period),
              value: skp.tahun,
            },
          ]}
        />
      </div>

      {!isSKPFetched ? (
        <Shimmer data-testid="loading-spinner-skp" />
      ) : (
        <div className="bg-white rounded-md mt-8 mb-[78px]">
          <Tabs onChange={setActiveTabIndex} selectedIndex={activeTabIndex}>
            <CustomTabList
              activeTabIndex={activeTabIndex}
              tabs={tabNamesSubmitted}
              disableInactiveTab
            />
            <TabPanels>
              <TabPanel>
                <TabHasilKerjaUtama
                  skp={skp}
                  onClickNext={() =>
                    setActiveTabIndex(TabIndex.HASIL_KERJA_TAMBAHAN)
                  }
                />
              </TabPanel>
              <TabPanel>
                <TabHasilKerjaTambahan
                  skp={skp}
                  onClickNext={() => setActiveTabIndex(TabIndex.PERILAKU_KERJA)}
                />
              </TabPanel>
              <TabPanel>
                <TabPerilakuKerja skp={skp} onClickNext={backToHomeKinerja} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
      )}
    </div>
  )
}

export default KinerjaPerencanaanWaitingApprovalApp
